import useUserInfo from "hooks/useUserInfo";

import { OfficeBillingPage } from "./officeBillingPage";
import { HqBillingPage } from "./hqBillingPage";

export const BillingPage = () => {
  const { accessLevel } = useUserInfo();

  const isOfficeAdmin = accessLevel === "Office";

  return <>{isOfficeAdmin ? <OfficeBillingPage /> : <HqBillingPage />}</>;
};
